import * as constants from "../contants/theme";

export const toggleTheme = (theme) => ({
  type: constants.TOGGLE_THEME,
  payload: theme
})

